import { useCallback, useContext } from "react";
import { API } from "../global/global";
import { AuthContext } from "../context/AuthContext";
import { toast } from "react-toastify";
import axios from "axios";

interface FiltrosDescarga {
  desde?: string;
  hasta?: string;
  etapa?: number;
  includeAll?: boolean;
}

const useDownloadMassivePDF = (
  loadingFunction: (value: React.SetStateAction<boolean>) => void
) => {
  const authContext = useContext(AuthContext);

  //Función que descarga el reporte Excel de servicios (como alternativa temporal)
  const descargarPDFsMasivo = useCallback(
    async (filtros?: FiltrosDescarga) => {
      if (!filtros?.desde || !filtros?.hasta) {
        toast.error("Es necesario seleccionar ambas fechas para la descarga", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        return;
      }

      if (filtros.desde > filtros.hasta) {
        toast.error("La fecha 'desde' debe ser anterior o igual a la fecha 'hasta'", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        return;
      }

      loadingFunction(true);
      
      try {
        // Usar el endpoint existente export_actividades
        const requestBody = {
          from: filtros.desde,
          to: filtros.hasta,
          etapas: [filtros.etapa || 3], // Array con la etapa específica
          porCobrar: false,
          cobrados: false,
          porPagar: false,
          pagados: false,
        };

        const response = await axios.post(`${API}/export_actividades`, requestBody, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + authContext.token,
          },
          responseType: 'blob'
        });

        const data = response.data;
        
        // Verificar que el blob no esté vacío
        if (data.size === 0) {
          toast.warning("No hay datos para descargar en el rango seleccionado", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          loadingFunction(false);
          return;
        }
        
        // Crear el link de descarga
        const url = window.URL.createObjectURL(data);
        const anchor = document.createElement("a");
        document.body.appendChild(anchor);
        anchor.href = url;
        
        // Generar nombre del archivo
        const nombreArchivo = `Servicios_${filtros.desde}_${filtros.hasta}.xlsx`;
        anchor.download = nombreArchivo;
        anchor.click();
        
        // Limpiar recursos
        window.URL.revokeObjectURL(url);
        document.body.removeChild(anchor);
        
        toast.success("¡Descarga completada! Se descargó un archivo Excel con los servicios.", {
          position: "top-right",
          autoClose: 4000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        
      } catch (error: any) {
        console.error("Error en descarga:", error);
        if (error.response?.status === 404) {
          toast.warning("No se encontraron servicios en el rango de fechas seleccionado", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        } else if (error.response?.status === 500) {
          toast.error("Error del servidor al generar el archivo", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        } else {
          toast.error("Error al descargar el archivo. Por favor, intente nuevamente.", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        }
      } finally {
        loadingFunction(false);
      }
    },
    [authContext.token, loadingFunction]
  );

  return { descargarPDFsMasivo };
};

export default useDownloadMassivePDF;
